import { useVariable } from '@softwareimaging/backstage';
import { FC } from 'react';
import { FaFolder, FaNewspaper } from 'react-icons/fa';
import { LargeBackground } from '../../components/background/LargeBackground';
import { Card } from '../../components/card/Card';
import { SearchBar } from '../../components/file/SearchBar';
import { DocumentListSection } from '../../components/oneDrive/DocumentList';
import { PageContainer } from '../../components/page/PageContainer';
import { PageSizer } from '../../components/page/PageSizer';
import { SectionHeader } from '../../components/page/SectionHeader';
import { Variables } from '../../services/backstage/config';
import { useFilesInFolder } from '../../services/graph/hooks/documentHelper';
import { useIntroduction } from '../../services/graph/hooks/introduction';
import { CategoryCarousel } from './CategoryCarousel';
import strings from './home.translations';
import { HomeQuickLinks } from './HomeQuickLinks';

export const HomePage: FC = () => {
  const introduction = useIntroduction();
  if (!introduction.data) {
    throw Error('Could not find site data');
  }

  const newslettersFolderId = useVariable<Variables>('newslettersFolderId');
  if (!newslettersFolderId) {
    throw Error('No newsletters folder ID defined');
  }

  return (
    <PageContainer>
      <div className="w-full relative h-[300px] md:h-[400px]">
        <LargeBackground className="absolute top-0 h-full w-full" />
        <PageSizer className="hidden md:block z-10 py-5 relative h-full">
          <div className="w-[40%] h-full flex flex-col gap-5 justify-center">
            <p className="text-4xl text-primary-800">{introduction.data.welcomeMessage}</p>
            <p>{introduction.data.text}</p>
          </div>
        </PageSizer>
      </div>
      <PageSizer className="md:hidden z-10 py-5 relative h-full -mt-[60px]">
        <div className="flex flex-col gap-5 justify-center border bg-white p-5 rounded-md">
          <p className="text-3xl text-primary-800">{introduction.data.welcomeMessage}</p>
          <p>{introduction.data.text}</p>
        </div>
      </PageSizer>
      <div className="w-full relative z-50">
        <PageSizer className="pb-5 md:py-5 relative flex flex-col gap-10 md:-mt-20">
          <Card className="flex flex-col gap-5">
            <SearchBar placeholder={strings.search} />
            <HomeQuickLinks />
          </Card>
          <div>
            <SectionHeader title={strings.categories.title} Icon={FaFolder} className="mb-5"></SectionHeader>
            <CategoryCarousel />
          </div>
          <DocumentListSection
            getDocuments={() => useFilesInFolder(newslettersFolderId)}
            includeCategories
            title={strings.newsletters}
            Icon={FaNewspaper}
          />
        </PageSizer>
      </div>
    </PageContainer>
  );
};
